export default {
  "account": {
    "curatedCollections": "Kolekcje kuratorowane",
    "curatedCollectionsInfo": "Poniżej znajdziesz wszystkie kolekcje, których jesteś kuratorem",
    "editProfile": "Edytuj profil",
    "likes": "Polubienia",
    "linkAccount": "Moje konto",
    "linkLogin": "Zaloguj się",
    "linkLoginJoin": "Zaloguj/Dołącz",
    "linkLogout": "Wyloguj",
    "myProfile": "Mój profil",
    "notifications": {
      "loggedIn": "Jesteś teraz zalogowany. Witamy!",
      "loggedOut": "Teraz jesteś wylogowany.",
      "noCollections": {
        "curated": "Nie jesteś jeszcze kuratorem żadnej kolekcji",
        "private": "Nie masz jeszcze prywatnych galerii",
        "public": "Nie masz jeszcze galerii publicznych"
      },
      "noLikedItems": "Nie polubiono jeszcze żadnych przedmiotów"
    },
    "privateCollections": "Galerie prywatne",
    "profile": "Moje polubienia i galerie",
    "profileSettings": "Ustawienia profilu",
    "publicCollections": "Galerie publiczne",
    "settings": "Ustawienia",
    "title": "Moje konto"
  },
  "actions": {
    "accept": "Akceptuj",
    "cancel": "Anuluj",
    "close": "zamknij",
    "continue": "kontynuuj",
    "download": "Ściągnij",
    "edit": "Edytuj",
    "feedback": "Twoja opinia",
    "goBack": "Wróć",
    "goHome": "Przejdź do strony głównej",
    "learnMore": "Ucz się więcej",
    "like": "Lubię",
    "move": "Przesuń",
    "next": "Następny",
    "pin": "Szpilka",
    "preview": "Podgląd",
    "previous": "Poprzedni",
    "providedBy": "Dostarczone przez {provider}",
    "reject": "Odrzuć",
    "save": "Zapisać",
    "send": "Wyślij",
    "share": "Udostępnij",
    "shareOn": "Udostępnij na {social}",
    "skip": "Pominąć",
    "viewAt": "Zobacz w {link}",
    "viewDocument": "Zobacz dokument"
  },
  "attribution": {
    "country": "Kraj:",
    "creator": "Twórca:",
    "date": "Data:",
    "institution": "Instytucja:",
    "title": "Tytuł:"
  },
  "automatedCardGroup": {
    "item": "Ostatnie pozycje",
    "organisation": "Organizacje",
    "place": "Miejsca",
    "time": "Polecane wieki",
    "topic": "Polecane tematy"
  },
  "blog": {
    "author": "Autor",
    "authors": "Autorzy",
    "blog": "Blog",
    "by": "autorstwa",
    "categories": "Kategorie",
    "category": "Kategoria",
    "posts": "Posty na blogu",
    "published": "Opublikowano w dniu {date}",
    "relatedPosts": "Powiązane posty"
  },
  "cardLabels": {
    "organisation": "Organizacja",
    "person": "Osoba",
    "place": "Miejsce",
    "theme": "Temat",
    "time": "Stulecie",
    "topic": "Temat"
  },
  "clearAllFilters": "wyczyść wszystkie filtry",
  "collections": {
    "actions": {
      "edit": "Edytuj kolekcję",
      "update": "Zaktualizuj kolekcję"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "projektanci",
          "name": "Projektant | Projektanci",
          "select": "Wybierz projektantów"
        },
        "proxy_dc_format": {
          "moreName": "techniki",
          "name": "Technika | Techniki",
          "select": "Wybierz techniki"
        },
        "proxy_dc_type": {
          "moreName": "typy przedmiotów",
          "name": "Typ elementu | Typy elementu",
          "select": "Wybierz typy przedmiotów"
        },
        "proxy_dcterms_medium": {
          "moreName": "materiały",
          "name": "Materiał | Materiały",
          "select": "Wybierz materiały"
        }
      }
    },
    "form": {
      "description": "Opis"
    },
    "notifications": {
      "update": "Kolekcja została zaktualizowana"
    }
  },
  "collectionsYouMightLike": "Kolekcje, które mogą Ci się spodobać",
  "colourSwatch": "Próbka koloru",
  "contentYouMightLike": "Treści, które mogą Ci się spodobać",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Więcej informacji",
      "about": "O kolekcjach Europeana",
      "forDevelopers": "Dla deweloperów",
      "help": "Pomoc",
      "meetUs": "Poznaj zespół",
      "provide": "Zostań dostawcą danych",
      "subscribe": "Zapisz się do naszego newslettera",
      "terms": "Regulamin i Polityka prywatności"
    },
    "headerNavigation": {
      "Collections": "Kolekcje",
      "explore": "Odkryj",
      "teachers": "Nauczyciele"
    }
  },
  "curatedAutomatically": "Wyselekcjonowane automatycznie przez Europeana",
  "dateFilter": {
    "endDate": "Data końcowa",
    "specificDate": "Konkretna data",
    "startDate": "Data rozpoczęcia",
    "to": "do"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Klucz API Europeana",
      "noRequests": "Na tej stronie nie użyto żadnych żądań do interfejsów API Europeana.",
      "settingsPageLinkText": "strona ustawień",
      "tip": "Wskazówka: jeśli masz już {apiKeyLink}, możesz wprowadzić go na {settingsPageLink} i zostanie on uwzględniony w tych linkach żądań API.",
      "title": "Żądania API"
    },
    "debug": "Debug",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Wpisz swój klucz Europeana API, który będzie używany w linkach do żądań API.",
          "label": "Klucz API"
        },
        "enabled": {
          "description": "Jeśli ta opcja jest włączona, menu debugowania będzie wyświetlane w stopce strony.",
          "label": "Włącz menu debugowania"
        }
      },
      "title": "Ustawienia"
    }
  },
  "delete": "Usuń",
  "depiction": "Obraz {title}",
  "directions": {
    "left": "W lewo",
    "right": "W prawo"
  },
  "edmIsShownAtLinkAlt": "Zobacz na stronie internetowej dostawcy",
  "entity": {
    "actions": {
      "cancel": "Anuluj",
      "pin": "Przypnij obiekt",
      "unpin": "Odepnij obiekt",
      "viewPinned": "Zobacz przypięte elementy"
    },
    "labels": {
      "entity": "Podmiot"
    },
    "notifications": {
      "deleted": "Twoja galeria została usunięta.",
      "error": {
        "unpin": "Podczas odpinania elementu wystąpił błąd. Spróbuj ponownie lub zgłoś problem."
      },
      "pin": "Ten element będzie wyświetlany u góry kolekcji „ {entity} ”. Powiadomimy Cię, kiedy ta zmiana będzie widoczna na stronie kolekcji.",
      "pinLimit": {
        "body": "Na razie możesz przypiąć tylko 24 obiekty na pierwszej stronie. Jeśli chcesz przypiąć ten obiekt, upewnij się, że najpierw odpiąłeś inny i spróbuj ponownie.",
        "title": "Za dużo przpiętych obiektów"
      },
      "pinned": "Obiekt został przypięty. Znajduje się teraz na górze pierwszej strony tej kolekcji. Synchronizacja u wszystkich użytkowników może potrwać do 24 godzin.",
      "select": "Wybierz powiązaną jednostkę, aby przypiąć/odpiąć element do/od niego.",
      "unpin": "Ten element przestanie się wyświetlać u góry kolekcji „ {entity} ”. Powiadomimy Cię, kiedy ta zmiana będzie widoczna na stronie kolekcji.",
      "unpinned": "Obiekt został odpięty. Nie znajduje się już na górze pierwszej strony tej kolekcji. Może minąć do 24 godzin, zanim zniknie dla wszystkich użytkowników."
    }
  },
  "error": "Błąd",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Nie jest to możliwe, ponieważ prywatne galerie są widoczne tylko dla ich twórcy. Jeśli znasz twórcę galerii, poproś go o upublicznienie galerii. Możesz też zgłosić ten problem za pomocą przycisku opinii.",
      "metaTitle": "Galeria nieautoryzowana",
      "title": "Ups! {newline} Próbujesz wyświetlić prywatną galerię innej osoby."
    },
    "itemNotFound": {
      "description": "Może to być spowodowane następującymi przyczynami: ten element nie istnieje lub; został wycofany z publikacji, ponieważ nie spełniał naszych kryteriów jakości lub; został zaktualizowany i ponownie opublikowany z nowym unikalnym identyfikatorem, w takim przypadku spróbuj ponownie znaleźć przedmiot.",
      "metaTitle": "Nie znaleziono przedmiotu",
      "title": "O nie! {newline} Nie mogliśmy znaleźć tego przedmiotu."
    }
  },
  "exhibitions": {
    "chapters": "Rozdziały",
    "credits": "Twórcy",
    "currentChapter": "Aktualny rozdział",
    "description": "Przeglądaj wystawy",
    "exhibitions": "Wystawa | Wystawy"
  },
  "explore": "Badać",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "kolory",
      "name": "Kolor | Kolory",
      "options": {
        "#000000": "Czarny",
        "#000080": "Ciemnoniebieski",
        "#00008B": "Ciemny niebieski",
        "#0000CD": "Średni niebieski",
        "#0000FF": "Niebieski",
        "#006400": "Ciemnozielony",
        "#008000": "Web Green",
        "#008080": "Cyraneczka",
        "#008B8B": "Ciemnobłękitny",
        "#00BFFF": "Deep Sky Blue",
        "#00CED1": "Ciemny turkus",
        "#00FA9A": "Średnia wiosenna zieleń",
        "#00FF00": "Zielony",
        "#00FF7F": "Wiosenna zieleń",
        "#00FFFF": "Cyjan",
        "#191970": "Niebieska północ",
        "#1E90FF": "Błękit nieba",
        "#20B2AA": "Jasna zieleń morska",
        "#228B22": "Zielony las",
        "#2E8B57": "Zielone morze",
        "#2F4F4F": "Ciemny Łupkowy Szary",
        "#32CD32": "Limonkowy",
        "#3CB371": "Średnia morska zieleń",
        "#40E0D0": "Turkus",
        "#4169E1": "Królewski niebieski",
        "#4682B4": "Stalowo - niebieski",
        "#483D8B": "Ciemnoniebieski łupek",
        "#48D1CC": "Średni turkus",
        "#4B0082": "Indygo",
        "#556B2F": "Ciemna Oliwka Zielona",
        "#5F9EA0": "Cadet Blue",
        "#6495ED": "Chaber",
        "#663399": "Rebecca Purple",
        "#66CDAA": "Medium Aquamarine",
        "#696969": "Dim Grey",
        "#6A5ACD": "Odcień niebieskiego",
        "#6B8E23": "Oliwkowo-szary",
        "#708090": "Łupkowy Szary",
        "#778899": "Jasny szary łupek",
        "#7B68EE": "Medium Slate Blue",
        "#7CFC00": "Lawn Green",
        "#7F0000": "Maroon Web",
        "#7F007F": "Fioletowy",
        "#7FFF00": "Chartreuse",
        "#7FFFD4": "Akwamaryn",
        "#800000": "Kasztanowy",
        "#800080": "Fioletowy",
        "#808000": "Oliwa",
        "#808080": "Web Grey",
        "#87CEEB": "Niebieskie niebo",
        "#87CEFA": "Jasny Błękitny",
        "#8A2BE2": "Niebieski fioletowy",
        "#8B0000": "Ciemno czerwony",
        "#8B008B": "Ciemna magenta",
        "#8B4513": "Brąz siodła",
        "#8FBC8F": "Ciemnozielona zieleń",
        "#90EE90": "Jasnozielony",
        "#9370DB": "Średni fiolet",
        "#9400D3": "Ciemny fiolet",
        "#98FB98": "Bladozielony",
        "#9932CC": "Ciemna orchidea",
        "#9ACD32": "Żółty zielony",
        "#A020F0": "Fioletowy",
        "#A0522D": "Sjena",
        "#A52A2A": "Brązowy",
        "#A9A9A9": "Ciemno szary",
        "#ADD8E6": "Jasny niebieski",
        "#ADFF2F": "Zielony żółty",
        "#AFEEEE": "Jasny turkus",
        "#B03060": "Kasztanowy",
        "#B0C4DE": "Jasny stalowoniebieski",
        "#B0E0E6": "Powder Blue",
        "#B22222": "Cegła ognista",
        "#B8860B": "Ciemna nawłoć",
        "#BA55D3": "Średnia orchidea",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Dark Khaki",
        "#BEBEBE": "Szary",
        "#C0C0C0": "Srebro",
        "#C71585": "Średni fioletowo-czerwony",
        "#CD5C5C": "Indyjski czerwony",
        "#CD853F": "Peru",
        "#D2691E": "Czekolada",
        "#D2B48C": "Dębnik",
        "#D3D3D3": "Jasnoszary",
        "#D8BFD8": "Oset",
        "#DA70D6": "Orchidea",
        "#DAA520": "Nawłoć",
        "#DB7093": "Jasnofioletowy czerwony",
        "#DC143C": "Karmazynowy",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Śliwka",
        "#DEB887": "Burlywood",
        "#E0FFFF": "Jasnobłękitny",
        "#E6E6FA": "Lawenda",
        "#E9967A": "Ciemny Łosoś",
        "#EE82EE": "Fioletowy",
        "#EEE8AA": "Blady nawłoci",
        "#F08080": "Jasny koral",
        "#F0E68C": "Khaki",
        "#F0F8FF": "Błękitny Alice",
        "#F0FFF0": "Spadzi",
        "#F0FFFF": "Lazur",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Pszenica",
        "#F5F5DC": "Beżowy",
        "#F5F5F5": "Biały dym",
        "#F5FFFA": "Krem miętowy",
        "#F8F8FF": "Ghost White",
        "#FA8072": "łosoś",
        "#FAEBD7": "Antyczna biel",
        "#FAF0E6": "Bielizna",
        "#FAFAD2": "Lightrodrod",
        "#FDF5E6": "Stara koronka",
        "#FF0000": "Czerwony",
        "#FF00FF": "Fuksja",
        "#FF1493": "Głęboki różowy",
        "#FF4500": "Pomarańczowy czerwony",
        "#FF6347": "Pomidor",
        "#FF69B4": "Ostry różowy",
        "#FF7F50": "Koral",
        "#FF8C00": "Ciemna pomarańcza",
        "#FFA07A": "Jasny łosoś",
        "#FFA500": "Pomarańczowy",
        "#FFB6C1": "Jasnoróżowy",
        "#FFC0CB": "Różowy",
        "#FFD700": "Złoto",
        "#FFDAB9": "Brzoskwinia",
        "#FFDEAD": "Navajo White",
        "#FFE4B5": "Mokasyn",
        "#FFE4C4": "Bisque",
        "#FFE4E1": "Mglista Róża",
        "#FFEBCD": "Blanched Almond",
        "#FFEFD5": "Bat Papaya",
        "#FFF0F5": "Lawendowy rumieniec",
        "#FFF5EE": "Muszla",
        "#FFF8DC": "Kukurydza",
        "#FFFACD": "Szyfon Cytrynowy",
        "#FFFAF0": "Kwiatowy Biały",
        "#FFFAFA": "Śnieg",
        "#FFFF00": "Żółty",
        "#FFFFE0": "Jasny zółty",
        "#FFFFF0": "kość słoniowa",
        "#FFFFFF": "Biały"
      },
      "select": "Wybierz kolory"
    },
    "COUNTRY": {
      "name": "Kraj dostarczający",
      "options": {
        "Albania": "Albania",
        "Austria": "Austria",
        "Belarus": "Białoruś",
        "Belgium": "Belgia",
        "Bosnia and Herzegovina": "Bośnia i Hercegowina",
        "Bulgaria": "Bułgaria",
        "Croatia": "Chorwacja",
        "Cyprus": "Cypr",
        "Czech Republic": "Republika Czeska",
        "Denmark": "Dania",
        "Estonia": "Estonia",
        "Europe": "Europa",
        "Finland": "Finlandia",
        "France": "Francja",
        "Georgia": "Gruzja",
        "Germany": "Niemcy",
        "Greece": "Grecja",
        "Holy See (Vatican City State)": "Stolica Apostolska (Państwo Watykańskie)",
        "Hungary": "Węgry",
        "Iceland": "Islandia",
        "Ireland": "Irlandia",
        "Israel": "Izrael",
        "Italy": "Włochy",
        "Latvia": "Łotwa",
        "Lithuania": "Litwa",
        "Luxembourg": "Luksemburg",
        "Macedonia": "Macedonia",
        "Malta": "Malta",
        "Moldova": "Moldova",
        "Montenegro": "Czarnogóra",
        "Netherlands": "Holandia",
        "Norway": "Norwegia",
        "Poland": "Polska",
        "Portugal": "Portugalia",
        "Romania": "Rumunia",
        "Russia": "Rosja",
        "Serbia": "Serbia",
        "Slovakia": "Słowacja",
        "Slovenia": "Słowenia",
        "Spain": "Hiszpania",
        "Sweden": "Szwecja",
        "Switzerland": "Szwajcaria",
        "Turkey": "Turcja",
        "Ukraine": "Ukraina",
        "United Kingdom": "Zjednoczone Królestwo",
        "United States of America": "Stany Zjednoczone Ameryki"
      },
      "select": "Wybierz kraje dostarczające"
    },
    "CREATOR": {
      "moreName": "twórcy",
      "name": "Twórca | Twórcy",
      "select": "Wybierz twórców"
    },
    "DATA_PROVIDER": {
      "moreName": "instytucje",
      "name": "Instytucja | Instytucje",
      "select": "Wybierz instytucje"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Układ obrazu",
      "options": {
        "landscape": "Poziomy",
        "portrait": "Pionowy"
      },
      "select": "Wybierz orientacje obrazu"
    },
    "IMAGE_SIZE": {
      "name": "Rozmiar obrazu | Rozmiary obrazu",
      "options": {
        "extra_large": "Bardzo duży 4MP+ (np. 2688 x 1520 px)",
        "large": "Duży 1-4 MP (np. 1920 x 1080 px)",
        "medium": "Średni 0,5-1 MP (np. 850 x 850 px)",
        "small": "Mały < 0,5 MP (np. 650 x 600 px)"
      },
      "select": "Wybierz rozmiary obrazu"
    },
    "LANGUAGE": {
      "name": "Język | Języki",
      "options": {
        "ar": "Arabski",
        "bg": "Bułgarski",
        "bs": "Bośniacki",
        "ca": "Kataloński",
        "cs": "Czeski",
        "cy": "Walijski",
        "da": "Duński",
        "de": "Niemiecki",
        "el": "Grecki",
        "en": "Angielski",
        "es": "Hiszpański",
        "et": "Estoński",
        "fi": "Fiński",
        "fr": "Francuski",
        "ga": "Irlandzki",
        "gd": "Gaelicki",
        "he": "Hebrajski",
        "hr": "Chorwacki",
        "hu": "Węgierski",
        "is": "Islandzki",
        "it": "Włoski",
        "lt": "Litewski",
        "lv": "Łotewski",
        "mk": "Macedoński",
        "mt": "Maltański",
        "mul": "Wiele języków",
        "nl": "Niderlandzki",
        "no": "Norweski",
        "pl": "Polski",
        "pt": "Portugalski",
        "ro": "Rumuński",
        "ru": "Rosyjski",
        "sk": "Słowacki",
        "sl": "Słoweński",
        "sq": "Albański",
        "sr": "Serbski",
        "sv": "Szwedzki",
        "tr": "Turecki",
        "uk": "Ukraiński"
      },
      "select": "Wybierz języki"
    },
    "MIME_TYPE": {
      "name": "Format plików | Formaty plików",
      "options": {
        "text/plain": "Zwykły tekst"
      },
      "select": "Wybierz formaty plików"
    },
    "PROVIDER": {
      "moreName": "agregatory",
      "name": "Agregator | Agregatorzy",
      "select": "Wybierz agregatorów"
    },
    "REUSABILITY": {
      "name": "Czy mogę to wykorzystać?",
      "options": {
        "open": "Tak",
        "permission": "Może, poproś o pozwolenie",
        "restricted": "Tak, z warunkami",
        "uncategorized": "Bez kategorii"
      },
      "select": "Wybierz, czy możesz używać tego"
    },
    "TYPE": {
      "name": "Rodzaj mediów",
      "options": {
        "3D": "3D",
        "IMAGE": "Obraz",
        "SOUND": "Audio",
        "TEXT": "Tekst",
        "VIDEO": "Wideo"
      },
      "select": "Wybierz rodzaje mediów"
    },
    "api": {
      "name": "Szukaj",
      "options": {
        "fulltext": "Zapisy z pełnym tekstem",
        "metadata": "Zapisy tylko z metadanymi"
      },
      "switch": "Wyszukiwanie tylko w treści artykułów z pełnym tekstem",
      "switchMoreInfo": "W tej kolekcji możesz wybrać, czego chcesz szukać: jeśli ten przełącznik jest włączony, wtedy będziesz szukał w tekście gazety i dokumentu; jeśli jest wyłączony, wtedy będziesz szukał w informacjach opisujących dany artykuł, tak jak zawsze robisz to w większości innych kolekcji."
    },
    "button": {
      "apply": "Zastosuj",
      "cancel": "Anuluj",
      "morefilters": "Więcej filtrów",
      "reset": "Resetuj",
      "showAll": "Pokaż wszystko {label}",
      "showLess": "Pokaż mniej {label}"
    },
    "collection": {
      "name": "Temat",
      "options": {
        "archaeology": "Archeologia",
        "art": "Sztuka",
        "fashion": "Moda",
        "industrial": "Dziedzictwo przemysłowe",
        "manuscript": "Rękopisy",
        "map": "Mapy i geografia",
        "migration": "Migracja",
        "music": "Muzyka",
        "nature": "Historia naturalna",
        "newspaper": "Gazety",
        "photography": "Fotografia",
        "sport": "Sport",
        "ww1": "I wojna światowa"
      },
      "select": "Wybierz motyw"
    },
    "contentTier": {
      "name": "Jakość obiektu",
      "options": {
        "*": "Obejmuje elementy niespełniające naszych kryteriów publikowania",
        "0": "Pokaż tylko elementy, które nie spełniają naszych kryteriów publikacji",
        "1": "Niska jakość",
        "2": "Średnia jakość",
        "3": "Wysoka jakość & wielokrotnego użytku z warunkami",
        "4": "Wysoka jakość & swobodnie wielokrotnego użytku"
      },
      "select": "Wybierz jakość pozycji"
    },
    "moreOptions": "Wyszukaj, aby znaleźć {0} więcej {1}.",
    "proxy_dc_format": {
      "name": "Format | Formaty",
      "select": "Wybierz formaty"
    },
    "proxy_dc_type": {
      "name": "Typ | Typy",
      "select": "Wybierz typy"
    },
    "proxy_dcterms_issued": {
      "name": "Data wydania"
    },
    "proxy_dcterms_medium": {
      "name": "Medium | Media",
      "select": "Wybierz media"
    }
  },
  "feedback": {
    "emailOptional": "Możemy chcieć podjąć działania następcze. Jeśli chcesz się z Nami skontaktować, wpisz swój adres e-mail.",
    "failed": "Żądanie nie powiodło się. Proszę spróbować ponownie.",
    "form": {
      "placeholders": {
        "email": "Wpisz swój adres e-mail",
        "feedback": "Wpisz tutaj swoją opinię"
      }
    },
    "policies": "Kontynuując, zgadzasz się na nasze {0} i przyjmujesz do wiadomości nasze {1}.",
    "privacyPolicy": "Polityka prywatności",
    "success": "Twoja opinia została wysłana.",
    "termsOfService": "Warunki usługi",
    "thankYou": "Dziękuję!",
    "title": "Wyślij opinię",
    "validEmail": "Wprowadzanie prawidłowego adresu e-mail",
    "validFeedback": "Twoja opinia musi składać się z co najmniej 5 słów"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Współtwórcy",
      "dcCoverage": "Miejsce i czas",
      "dcCreator": "Twórca",
      "dcDate": "Data",
      "dcDescription": "Opis",
      "dcDuration": "Długość",
      "dcFormat": "Format",
      "dcIdentifier": "Identyfikator",
      "dcLanguage": "Język",
      "dcPublisher": "Wydawca",
      "dcRelation": "Relacje",
      "dcRights": "Prawa autorskie",
      "dcSource": "Źródło",
      "dcSubject": "Temat",
      "dcTitle": "Tytuł",
      "dcType": "Rodzaj przedmiotu",
      "dctermsCreated": "Data utworzenia",
      "dctermsExtent": "Zakres",
      "dctermsHasPart": "Składa się z",
      "dctermsHasVersion": "Ma wersję",
      "dctermsIsFormatOf": "Jest formatu",
      "dctermsIsPartOf": "jest częścią",
      "dctermsIsReferencedBy": "Jest przywoływany przez",
      "dctermsIsReplacedBy": "Jest zastąpione przez",
      "dctermsIsRequiredBy": "Jest wymagane przez",
      "dctermsIssued": "Data wydania",
      "dctermsMedium": "Medium",
      "dctermsProvenance": "Pochodzenie",
      "dctermsReferences": "Przywołuje",
      "dctermsSpatial": "Miejsca",
      "dctermsTOC": "Spis treści",
      "dctermsTemporal": "Okres",
      "edmCountry": "Kraj dostarczający",
      "edmCurrentLocation": "Aktualna lokalizacja",
      "edmDataProvider": "Instytucja dostarczająca",
      "edmHasMet": "Spotkał",
      "edmIncorporates": "Zawiera",
      "edmIntermediateProvider": "Dostawca pośredni",
      "edmIsDerivativeOf": "Jest pochodną",
      "edmIsRelatedTo": "Odnosi się do",
      "edmIsRepresentationOf": "Reprezentuje",
      "edmIsSimilarTo": "Jest podobna do",
      "edmIsSuccessorOf": "Jest następcą",
      "edmProvider": "Dostawca",
      "edmRealizes": "Realizuje",
      "edmRights": "Licencja na media w tym rekordzie (chyba że określono inaczej)",
      "edmUgc": "Treści dodane przez użytkowników",
      "europeanaCollectionName": "Nazwa Kolekcji",
      "keywords": "Słowa kluczowe (dostarczone przez społeczność)",
      "timestampCreated": "Data utworzenia rekordu",
      "timestampUpdate": "Data zaktualizowania rekordu",
      "wasPresentAt": "Był obecny w/na",
      "year": "Rok"
    },
    "webResource": {
      "about": "RDF Informacje",
      "dcDescription": "Opis",
      "ebucoreHasMimeType": "Typ MIME Ebucore",
      "edmRights": "Licencja na ten zasób medialny",
      "rdfAbout": "RDF Informacje"
    }
  },
  "filter": "Filtr",
  "filterResults": "Wyniki filtrowania",
  "footer": {
    "customiseWebsiteLanguage": "Dostosuj język witryny",
    "disclaimerLine1": "Europeana jest inicjatywą Unii Europejskiej, finansowaną z unijnego Connecting Europe Facility oraz przez państwa członkowskie Unii Europejskiej. Usługi Europeany, w tym niniejsza strona internetowa, są prowadzone przez konsorcjum kierowane przez Fundację Europeana na podstawie umowy o świadczenie usług zawartej z Komisją Europejską.",
    "disclaimerLine2": "Komisja Europejska nie gwarantuje dokładności informacji i nie ponosi żadnej odpowiedzialności w odniesieniu do informacji na tej stronie internetowej. Ani Komisja Europejska, ani żadna osoba działająca w imieniu Komisji Europejskiej nie ponosi odpowiedzialności za dokładność lub wykorzystanie informacji na tej stronie internetowej.",
    "findUsElsewhere": "Znajdź nas w innych miejscach",
    "imageDescription": "Finansowane przez Unię Europejską",
    "navigation": {
      "MoreInfoLabel": "Więcej informacji",
      "about": "O nas",
      "accessibility": "Dostępność",
      "cookies": "Pliki cookie",
      "forDevelopers": "Dla deweloperów",
      "help": "Pomoc",
      "privacy": "Polityka prywatności",
      "provide": "Zostań dostawcą danych",
      "subscribe": "Zapisz się do naszego newslettera",
      "terms": "Warunki usługi"
    },
    "ourMission": "Nasza misja",
    "ourMissionQuote": "Europeana wspiera sektor dziedzictwa kulturowego w jego transformacji cyfrowej. Rozwijamy wiedzę specjalistyczną, narzędzia i polityki, aby uwzględnić zmiany cyfrowe i zachęcać do partnerstwa wspierającego innowacje."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Przeglądaj nasze galerie",
    "galleries": "Galerie"
  },
  "goToRecord": "Przejdź do rekordu",
  "header": {
    "backToMenu": "Zamknij pole wyszukiwania",
    "clearQuery": "Wyczyść zapytanie",
    "closeSidebar": "Zamknij menu",
    "entireCollection": "Wyszukaj {query} w całej naszej kolekcji",
    "europeanaHome": "Strona główna Europeany",
    "inCollection": "Wyszukaj {query} w {collection}",
    "navigation": {
      "about": "O nas",
      "collections": "Kolekcje",
      "europeanaClassroom": "Dla nauczycieli",
      "help": "Pomoc",
      "home": "Dom",
      "pro": "Dla profesjonalistów",
      "stories": "Historie"
    },
    "quickSearch": "Szybkie wyszukiwanie",
    "searchFor": "Wyszukaj {query}",
    "searchForEverything": "Szukaj wszystkiego",
    "searchForEverythingInCollection": "Szukaj wszystkiego w {collection}",
    "searchForEverythingInEntireCollection": "Szukaj wszystkiego w całej naszej kolekcji",
    "searchForm": "Formularz wyszukiwania",
    "showSidebar": "Pokaż menu",
    "sideNavigation": "Nawigacja boczna"
  },
  "homeLinkAlt": "Strona główna Europeana",
  "homePage": {
    "discoverEditorial": "Najnowsze historie",
    "storiesCTA": "Zobacz wszystkie historie",
    "subHeadline": "Wyszukuj, zapisuj i udostępniaj dzieła sztuki, książki, filmy i muzykę z tysięcy instytucji kulturalnych",
    "themesCTA": "Zobacz wszystkie motywy",
    "themesTitle": "Eksploruj według motywu",
    "title": "Odkryj {digital} dziedzictwo kulturowe Europy",
    "titleDigital": "cyfrowe"
  },
  "imageSlider": {
    "handle": "Uchwyt suwakowy"
  },
  "items": {
    "itemCount": "1 pozycja |Pozycje: {count}",
    "itemOf": "{max} z {count} elementów",
    "recent": "Ostatnie pozycje",
    "recommended": "Polecane obiekty",
    "youMightLike": "Przedmioty, które mogą Ci się spodobać"
  },
  "klaro": {
    "main": {
      "acceptAll": "Akceptuj wszystkie",
      "acceptSelected": "Zaakceptuj wybrane",
      "consentModal": {
        "description": "Poważnie traktujemy prywatność Twoich danych. Tutaj możesz ocenić i dostosować usługi, z których chcielibyśmy korzystać na tej stronie. Ty rządzisz! Włącz lub wyłącz usługi według własnego uznania.",
        "title": "Usługi, z których chcielibyśmy skorzystać."
      },
      "consentNotice": {
        "description": "Dbamy o Twoją prywatność i wykorzystujemy dane tylko po to, aby poprawić Twoje doświadczenia. Nie wykorzystujemy żadnych danych osobowych do celów reklamowych. Możesz zmienić swoją zgodę co 15 dni.",
        "learnMore": "Pozwól mi wybrać"
      },
      "decline": "Odmawiam",
      "ok": "Dobra",
      "purposes": {
        "essential": {
          "description": "Usługi te są niezbędne do prawidłowego funkcjonowania tej witryny. Obejmują one widok wyników wyszukiwania i preferencje językowe, zachowują stan zalogowania i zapewniają bezpieczeństwo Twojej wizyty. Nie możesz ich wyłączyć, ponieważ w przeciwnym razie strona nie działałaby poprawnie.",
          "title": "Niezbędne usługi w zakresie bezpieczeństwa i dostosowywania"
        },
        "usage": {
          "description": "Usługi te zbierają informacje, aby pomóc nam lepiej zrozumieć, w jaki sposób strona internetowa jest używana i gdzie są punkty bólu, umożliwiając nam dokonywanie świadomych wyborów w celu poprawy doświadczenia użytkownika.",
          "title": "Usługi do przechwytywania wykorzystania witryny i informacji zwrotnych"
        }
      },
      "service": {
        "disableAll": {
          "description": "Użyj tego przełącznika, aby włączyć lub wyłączyć wszystkie usługi opcjonalne.",
          "title": "Włącz lub wyłącz wszystkie usługi"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Pomaga ulepszyć naszą stronę internetową, od czasu do czasu stosując eksperymentalne zmiany.",
        "title": "Testy A/B"
      },
      "auth-strategy": {
        "description": "Zapamiętuje strategię autoryzacji używaną do logowania.",
        "title": "Strategia Auth"
      },
      "debugSettings": {
        "description": "Pomaga w debugowaniu żądań API",
        "title": "Przełącznik debugowania"
      },
      "hotjar": {
        "description": "Aktywuje widget ankiety dający możliwość odpowiadania na nasze ankiety satysfakcji odwiedzających.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Zapamiętuje preferowany język interfejsu do przyszłego dostępu.",
        "title": "Kod języka"
      },
      "jira-servicedesk": {
        "description": "Aktywuje widget opinii, dając Ci możliwość skontaktowania się z nami.",
        "title": "Jira service desk"
      },
      "matomo": {
        "description": "Gromadzi anonimowe statystyki dotyczące interakcji odwiedzających z witryną.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Wyświetla powiadomienie, gdy nowe funkcje stają się dostępne.",
        "title": "Powiadomienie o nowej funkcji"
      },
      "searchResultsView": {
        "description": "Zapamiętuje czy wolisz widzieć wyniki wyszukiwania w widoku listy lub siatki.",
        "title": "Widok wyników wyszukiwania (lista/siatka)"
      }
    }
  },
  "layout": {
    "skipToMain": "Przejdź do zawartości strony"
  },
  "learnMore": "Dowiedz się o źródle tego opisu",
  "loading": "Ładowanie",
  "loadingResults": "Ładowanie wyników",
  "messages": {
    "copyToClipboardSuccess": "Skopiowane do schowka",
    "externalContentError": "Nie można załadować treści zewnętrznej",
    "notFound": "Nie znaleziono",
    "paginationLimitExceeded": "Możliwe jest wyświetlenie tylko pierwszych {limit} wyników wyświetlania."
  },
  "modal": {
    "download": {
      "clickToCopy": "Kilknij na opis, aby go skopiować",
      "modalIntro": "Jeśli używasz tego elementu w Internecie lub w innym miejscu, nie zapomnij wyświetlić obok niego następującego opisu:",
      "modalTitle": "Powiedz dziękuję"
    }
  },
  "multilingual": {
    "automated": "Tłumaczenie zautomatyzowane",
    "enrichment": "Rozszerzenie w ramach projektów partnerskich",
    "other": "Inne języki",
    "stopTranslating": "Przestań tłumaczyć ten element na {0}.",
    "translateLanguage": "Czy chciałbyś zobaczyć ten element w {0}?",
    "translateQuotaError": "Usługa tłumaczeń jest chwilowo niedostępna. Spróbuj ponownie później."
  },
  "newFeatureNotification": {
    "dismiss": "Zamknij",
    "readMore": "Czytaj więcej",
    "text": {
      "searchFilters": "Możesz teraz wyszukiwać wartości w poszczególnych filtrach; Sprawdź to!"
    }
  },
  "newWindow": "otwiera się w nowym oknie",
  "noMoreResults": "Nie ma więcej wyników dla zapytania wyszukiwania.",
  "noResults": "Brak wyników",
  "of": "Z",
  "organisation": {
    "city": "Miasto",
    "country": "Kraj",
    "englishName": "Nazwa angielska",
    "nameAcronym": "Nazwa akronim"
  },
  "pageHasLoaded": "załadował",
  "pageNumber": "Numer strony",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Nazwa"
        },
        "title": "Organizacje"
      },
      "persons": {
        "title": "Osoby"
      },
      "places": {
        "title": "Miejsca"
      },
      "table": {
        "items": "Elementy",
        "name": "Nazwa"
      },
      "times": {
        "title": "Czasy"
      },
      "topics": {
        "title": "Tematy"
      }
    }
  },
  "pagination": {
    "label": "Paginacja"
  },
  "readMore": "Czytaj więcej",
  "recommendation": {
    "prompts": {
      "accept": "Kciuk w górę, aby dodać do galerii",
      "reject": "Kciuk w dół, jeśli ci się nie podoba"
    }
  },
  "record": {
    "IIIFViewer": "Przeglądarka IIIF",
    "actions": {
      "pin": "Przypinanie elementu do dostępnych encji"
    },
    "allMetaData": "Wszystkie metadane",
    "copyEmbedLabel": "Kod do umieszczenia (kliknij, aby skopiować)",
    "exploreMore": "Odkryj więcej",
    "extendedInformation": "Informacje rozszerzone",
    "goodToKnow": "Warto wiedzieć",
    "hideAll": "Ukryj wszystkie informacje",
    "location": "Lokalizacja",
    "locationOnMap": "Lokalizacja na mapie",
    "mediaPlayer": "Odtwarzacz multimediów",
    "record": "Rekord",
    "showAll": "Pokaż wszystkie informacje",
    "similarItems": "Podobne obiekty",
    "status": {
      "unpublished": "[Pozycja nieopublikowana]"
    },
    "transcription": "Transkrypcja",
    "transcriptionDisclaimer": "Treść ta jest tworzona przez społeczeństwo, a nie przez instytucję, która dostarczyła tę pozycję."
  },
  "related": {
    "editorial": {
      "title": "Historie, które mogą Ci się spodobać"
    }
  },
  "relatedCollections": "Powiązane kolekcje",
  "removeFilter": "Usuń filtr {filterLabel}",
  "reset": "Resetuj",
  "resourceWikimedia": "Źródło z Wikimedia Commons",
  "results": "Wyniki",
  "resultsFor": "Wyniki dla {0}",
  "resultsLimitWarning": "Dodatkowe wyniki nie są wyświetlane, ponieważ wyświetlanych jest tylko pierwsze 1000 najbardziej odpowiednich wyników. Jeśli nie znalazłeś tego, czego szukasz, rozważ zawężenie wyszukiwania.",
  "resultsWithin": "Wyniki w granicach {0} {1} dla {2}",
  "search": {
    "boost": {
      "placeholder": "Wpisz zapytanie zwiększające pole"
    },
    "title": "Szukaj"
  },
  "searchHasLoaded": "{0} zwróconych wyników",
  "searchPlaceholder": "Przeszukaj ponad 50 milionów przedmiotów",
  "searchResults": "Szukaj",
  "searchResultsFor": "{0} - Szukaj",
  "searchSuggestions": "Sugestie wyszukiwania",
  "searchTier": {
    "button": {
      "hide": "Ukryj te elementy",
      "show": "Pokaż te elementy"
    },
    "text": {
      "hide": "Wyświetlane są elementy, które nie spełniają naszych kryteriów publikowania.",
      "show": "Więcej elementów pasuje do wyszukiwania, ale nie spełnia naszych kryteriów publikowania."
    }
  },
  "searchViews": {
    "grid": "Widok siatki",
    "list": "Widok listy",
    "mosaic": "Widok mozaiki"
  },
  "set": {
    "actions": {
      "addTo": "Dodaj do galerii",
      "create": "Utwórz galerię",
      "createNew": "Utwórz nową galerię",
      "delete": "Usuń galerię",
      "edit": "Edytuj galerię",
      "update": "Zaktualizuj galerię"
    },
    "form": {
      "description": "Opis galerii",
      "private": "Zachowaj tę galerię jako prywatną",
      "required": "Pole wymagane",
      "title": "Nazwa galerii"
    },
    "labels": {
      "curatedBy": "Kurator",
      "private": "Prywatna galeria"
    },
    "notifications": {
      "deleted": "Twoja galeria została usunięta.",
      "likeLimit": {
        "body": "Przepraszamy, ale w tej chwili możesz polubić maksymalnie 100 pozycji. Wkrótce usuniemy ten limit!",
        "title": "100 polubień"
      },
      "updated": "Obiekt został dodany do galerii."
    },
    "prompts": {
      "delete": "Czy na pewno chcesz usunąć tę galerię? Jeśli ją usuniesz, utracisz wszystkie dodane do niej elementy."
    }
  },
  "showLess": "Pokaż mniej",
  "showMore": "Pokaż więcej",
  "sideFilters": {
    "noOptions": "Nie ma dostępnych opcji do wyboru",
    "search": "Szukaj"
  },
  "statuses": {
    "liked": "Lubiana",
    "pinned": "Przypięty"
  },
  "storiesPage": {
    "title": "Historie"
  },
  "website": "Strona internetowa",
  "youMightAlsoLike": "Możesz też polubić"
};
